import React from "react";
import sanitizeHtml from "sanitize-html";

const defaultOptions = {
  allowedTags: ["b", "i", "em", "strong", "a", "p", "h1", "h2", "ol", "ul", "li", "blockquote", "u", "s", "br"],
  allowedAttributes: {
    a: ["href"],
    p: ["class"],
  },
};

export const sanitize = (dirty: string, options: sanitizeHtml.IOptions) => ({
  __html: sanitizeHtml(dirty, { ...defaultOptions, ...options }) || "",
});

export const htmlToPlainText = (html: string = "") => {
  if (!html) {
    return "";
  }
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

type SanitizeHTMLProps = {
  html: string;
  className?: string;
  options?: sanitizeHtml.IOptions;
};

export const SanitizeHTML: React.FC<SanitizeHTMLProps> = ({ html, className = "", options = {} }) => (
  <div className={className} dangerouslySetInnerHTML={sanitize(html, options)} />
);

type SafeHTMLProps = {
  html: string;
  className?: string;
};

export const SafeHTML: React.FC<SafeHTMLProps> = ({ html, className = "" }) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: html }} />
);
